import React from 'react';
import {FeaturesGrid, FeaturesGridProps} from './FeaturesGrid';
import {SubnavSection, SubnavSectionConfigProps} from '../../elements/subnav/SubnavSection';
import {AccentColorOptions} from 'epic-ue-theme';

export interface FeaturesGridSectionProps {
    sectionConfig: SubnavSectionConfigProps;
    featuresIconAccentColor?: AccentColorOptions;
    features?: FeaturesGridProps;
}

export const FeaturesGridSection = ({
    featuresIconAccentColor,
    sectionConfig,
    features = {}
}: FeaturesGridSectionProps): JSX.Element => {
    return (
        <SubnavSection sectionConfig={sectionConfig}>
            <FeaturesGrid
                {...features}
                accentColor={sectionConfig.accentColor}
                featuresIconAccentColor={featuresIconAccentColor}
            />
        </SubnavSection>
    );
};
